import { render, staticRenderFns } from "./marketGoodsItemManageList.vue?vue&type=template&id=57353e5e&scoped=true"
import script from "./marketGoodsItemManageList.vue?vue&type=script&lang=js"
export * from "./marketGoodsItemManageList.vue?vue&type=script&lang=js"
import style0 from "./marketGoodsItemManageList.vue?vue&type=style&index=0&id=57353e5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57353e5e",
  null
  
)

export default component.exports